import { render, staticRenderFns } from "./Restoration2_1.vue?vue&type=template&id=a82b805a&scoped=true"
import script from "./Restoration2_1.vue?vue&type=script&lang=js"
export * from "./Restoration2_1.vue?vue&type=script&lang=js"
import style0 from "./Restoration2_1.vue?vue&type=style&index=0&id=a82b805a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82b805a",
  null
  
)

export default component.exports